import {
  EVENT_GENRE,
  EVENT_SECTOR,
  FOREX_LIST,
  EXCHANGE_LIST,
  FUTURE_COMMODITY_EXCHANGE_LIST,
  API_CONTROL_PANEL_INPUT_TYPE
} from "@/assets/apiDocs/api_constants.js";

export const v2_api_category = [
  "Get Started",
  "Stock API",
  "Futures & Commodities API",
  "Crypto API",
  // "Forex API",
  "Reference API"
];
export const v2_api_menu_by_category = {
  "Get Started": [
    "Introduction",
    "Security",
    "Credit System",
    "Community Support and SDK",
    "URL Format",
    "Google Sheet and Excel Plug-in",
    "Error Code"
  ],
  "Stock API": [
    // "US Realtime Stock Price",
    // "Realtime Stock Price",
    "Historical Stock Price",
    // "Stock Technical Indicators",
    "Company Financials",
    "Company Profile",
    "Company Financial Summary",
    "Ownership Structure",
    "Insider Transaction",
    "SEC Filing Link",
    "Stock News",
    "Corporate Splits",
    "Corporate Dividends",
    "Stock Analyst Ratings"
  ],
  "Futures & Commodities API": [
    "Realtime Futures and Commodities Price",
    "Historical Futures and Commodities Price"
  ],
  "Crypto API": ["Historical Crypto Price"],
  // "Forex API": ["Realtime Forex Rates", "Historical Forex Rates"],
  "Reference API": ["Stock Coverage", "Futures and Commodities Coverage", "Crypto Coverage"]
};

const tickers_default_data = {
  table_data: [
    "tickers",
    "Required",
    'Choose the symbol of a company. Please visit Stock Coverage API for all the ticker that we support. Multiple tickers are supported. Seperate tickers with comma such as "AAPL,WORK".'
  ]
};

const tickers_optional_data = {
  table_data: [
    "tickers",
    "Optional",
    'Choose the symbol of a company. Please visit Stock Coverage API for all the ticker that we support. Multiple tickers are supported. Seperate tickers with comma such as "AAPL,WORK".'
  ]
};

const symbols_default_data = {
  table_data: [
    "symbols",
    "Required",
    'Choose the symbol of a commodity or future. Please visit Commodity Coverage API for all the symbols that we support. Multiple symbols are supported. Seperate symbols with comma such as "COMEX GOLD DEC 2020,LME TIN MAR 2020".'
  ]
};

const data_type_param = [
  "dataType",
  "Optional",
  "By default, datatype=json. if datatype=csv specified, returns response result as a CSV (comma separated value) file"
];
const access_key_param = ["accessKey", "Required", "Claim your API key here"];

const input_param_table_header = ["Parameters", "Requirement", "Details"];
const response_param_table_header = ["Name", "Type", "Description"];

const V2_API = {
  // "US Realtime Stock Price": {
  //   api_category: v2_api_category[1],
  //   costs: ["1 credit per data point"],
  //   description: [
  //     "Intraday US Stock Price API listens to 5 US Exchanges and offers institution-grade data. Server-Sent Events (SSE) and WebSocket are supported for realtime streaming upon request."
  //   ],
  //   feature: [
  //     "This real time stock price API covers real time price quote over 9,500 companies, indices and ETFs, traded in the major exchanges around the world. Find all the companies and exchanges that we support, please check Stock Coverage API",
  //     "This API is updated in real time with no delay.",
  //     "Realtime price history goes back one month.",
  //     "This API is updated every minute (Few stock prices may delay more than 1 minute depending on the liquidity of the stock).",
  //     "All intraday quotes are provided in local time.",
  //     "All intraday quotes are adjusted for corporate actions.",
  //     "Up to 50 stock quotes can be requested at a time.",
  //     "Support RESTful API (JSON & CSV) and SSE (Server-Sent Events)"
  //   ],
  //   base_url: "https://api.unibit.ai/v2/stock/us/realtime/",
  //   template_urls: [
  //     "https://api.unibit.ai/v2/stock/us/realtime?tickers={{ticker list}}&startDate={{YYYY-MM-DD}}&endDate={{YYYY-MM-DD}}&startMinute={{HH:MM:SS}}&endMinute={{HH:MM:SS}}&size={{a positive number}}&selectedFields={{field list}}&dataType={{json or csv}}&accessKey={{your key}}"
  //   ],
  //   example_urls: [
  //     "https://api.unibit.ai/v2/stock/us/realtime?tickers=AAPL&startDate=2020-01-21&endDate=2020-01-21&startMinute=15:30:00&endMinute=20:00:00&selectedFields=All&accessKey=Demo"
  //   ],
  //   csv_urls: [
  //     "https://api.unibit.ai/v2/stock/us/realtime?tickers=AAPL&startDate=2020-01-21&endDate=2020-01-21&startMinute=15:30:00&endMinute=20:00:00&selectedFields=All&dataType=csv&accessKey=Demo"
  //   ],
  //   input_params: {
  //     query_params: {
  //       description: "",
  //       table_header: input_param_table_header,
  //       table_data: [
  //         tickers_default_data.table_data,
  //         ["startDate", "Optional", "Choose the start date (in \"YYYY-MM-DD\" Format). Ex. \"2019-08-25\". Real time stock prices go back 1 week. Default date is today.(UTC time) "],
  //         ["endDate", "Optional", "Choose the end date (in \"YYYY-MM-DD\" Format). Ex. \"2019-08-30\". Real time stock prices only go back 1 week. Default date is today.(UTC time) "],
  //         ["startMinute", "Optional", "Choose the specific intraday period (in \"HH:MM:SS\" format). Ex. \"11:00:00\". Default time is \"00:00:00\". (UTC time)"],
  //         ["endMinute", "Optional", "Choose the specific intraday period (in \"HH:MM:SS\" format). Ex. \"12:00:00\". Default time is \"23:59:59\". (UTC time)"],
  //         ["size", "Optional", "Set the max number of datapoints to retreive. If not specified, this query returns all avaliable datapoints requested between the time specified. Otherwise, it returns the number (size n) of objects (JSON) or rows (CSV) per ticker. Max is 10,000."],
  //         ["selectedFields", "Optional", "Choose a list (comma separated) of data fields (in snake case) to return. Default is \"all\"."],
  //         data_type_param,
  //         access_key_param
  //       ]
  //     }
  //   },
  //   response_params: {
  //     description: "",
  //     table_header: response_param_table_header,
  //     table_data: [
  //       [
  //         "ticker",
  //         "String",
  //         "Returns the symbol of a company or companies"
  //       ],
  //       [
  //         "date",
  //         "String",
  //         "Returns the date realtime price is traded on. Date format is: yyyy-mm-dd"
  //       ],
  //       [
  //         "minute",
  //         "String",
  //         "Returns the minute realtime price is traded on. Minute format is: hh:mm"
  //       ],
  //       [
  //         "latest_price",
  //         "Number",
  //         "Returns the latest intraday price for the stocks selected. Ex: \"123.45\""
  //       ],
  //       [
  //         "volume",
  //         "Number",
  //         "Returns the aggregated intraday trade volume for the stocks selected. Ex: \"123\""
  //       ],
  //       [
  //         "price_change_ratio",
  //         "Number",
  //         "Returns the intraday price change ratio for the stocks selected. Ex: \"123\""
  //       ],
  //       ["timestamp", "Number", "Returns the timestamp of the price is traded on"]
  //     ]
  //   }
  // },

  // "Realtime Stock Price": {
  //   api_category: v2_api_category[1],
  //   costs: ["1 credit per data point"],
  //   description: [
  //     "Realtime Stock Prices API offers realtime stock quotes for securities trading around the globe in 49 exchanges. This API prints the latest price quote every minute in local time."
  //   ],
  //   feature: [
  //     "This realtime stock price API covers realtime price quote over 70,000 asset, including common stock and ETF.",
  //     "Exchange covered: All.",
  //     "Realtime price history goes back one month.",
  //     "This API is updated every minute (Few stock prices may delay more than 1 minute depending on the liquidity of the stock).",
  //     "All intraday quotes are provided in local time with GMT offset.",
  //     "All intraday quotes are adjusted for corporate actions.",
  //     "Up to 50 stock quotes can be requested at a time."
  //   ],
  //   base_url: "https://api.unibit.ai/v2/stock/realtime/",
  //   template_urls: [
  //     "https://api.unibit.ai/v2/stock/realtime?tickers={{ticker list}}&startDate={{YYYY-MM-DD}}&endDate={{YYYY-MM-DD}}&startMinute={{HH:MM:SS}}&endMinute={{HH:MM:SS}}&size={{a positive number}}&selectedFields={{field list}}&dataType={{json or csv}}&accessKey={{your key}}"
  //   ],
  //   example_urls: [
  //     "https://api.unibit.ai/v2/stock/realtime?tickers=AAPL&startDate=2019-10-30&endDate=2019-10-30&startMinute=09:30:00&endMinute=16:00:00&selectedFields=All&accessKey=Demo"
  //   ],
  //   csv_urls: [
  //     "https://api.unibit.ai/v2/stock/realtime?tickers=AAPL,WORK&startDate=2019-10-30&endDate=2019-10-30&startMinute=09:30:00&endMinute=16:00:00&selectedFields=All&dataType=csv&accessKey=Demo"
  //   ],
  //   input_params: {
  //     query_params: {
  //       description: "",
  //       table_header: input_param_table_header,
  //       table_data: [
  //         tickers_default_data.table_data,
  //         [
  //           "startDate",
  //           "Optional",
  //           'Choose the start date (in "YYYY-MM-DD" Format). Ex. "2019-08-25". Real time stock prices go back 1 month. Default date is today.(Exchange market local time) '
  //         ],
  //         [
  //           "endDate",
  //           "Optional",
  //           'Choose the end date (in "YYYY-MM-DD" Format). Ex. "2019-08-30". Real time stock prices only go back 1 month. Default date is today.(Exchange market local time) '
  //         ],
  //         [
  //           "startMinute",
  //           "Optional",
  //           'Choose the specific intraday period (in "HH:MM:SS" format). Ex. "11:00:00". Default time is "00:00:00". (Exchange market local time)'
  //         ],
  //         [
  //           "endMinute",
  //           "Optional",
  //           'Choose the specific intraday period (in "HH:MM:SS" format). Ex. "12:00:00". Default time is "23:59:59". (Exchange market local time)'
  //         ],
  //         [
  //           "size",
  //           "Optional",
  //           "Set the max number of datapoints to retreive. If not specified, this query returns all avaliable datapoints requested between the time specified. Otherwise, it returns the number (size n) of objects (JSON) or rows (CSV) per ticker. Max is 9,999,999."
  //         ],
  //         [
  //           "selectedFields",
  //           "Optional",
  //           'Choose a list (comma separated) of data fields (in snake case) to return. Default is "all".'
  //         ],
  //         data_type_param,
  //         access_key_param
  //       ]
  //     }
  //   },
  //   response_params: {
  //     meta_data: {
  //       ticker: "AAPL",
  //       date: "02/02/2020"
  //     },
  //     description: "",
  //     table_header: response_param_table_header,
  //     table_data: [
  //       ["ticker", "String", "Returns the symbol of a company or companies"],
  //       [
  //         "date",
  //         "String",
  //         "Returns the date realtime price is traded on. Date format is: yyyymmdd"
  //       ],
  //       [
  //         "minute",
  //         "String",
  //         "Returns the minute realtime price is traded on. Minute format is: hh:mm"
  //       ],

  //       ["price", "Number", 'Returns the price for the stocks selected. Ex: "123.45"'],
  //       ["volume", "Number", "Returns the volume of the stock is traded"],
  //       ["timezone", "String", "Returns local timezone of the exchange where the stock is traded"],
  //       ["timestamp", "Number", "Returns the timestamp of the price is traded on"],
  //       ["utc_offset", "Number", "Returns the difference between local timestamp and UTC timestamp"]
  //     ]
  //   }
  // },

  "Historical Stock Price": {
    api_category: v2_api_category[1],
    costs: ["10 credit per data point"],
    description: [
      "Historical Stock Price API offers End of Day (EOD) prices for active stocks trading around the globe in the past 20 years."
    ],
    feature: [
      "Over 70,000 global stocks, ETFs and Mutual Funds, traded in the major exchanges.",
      "This API is updated every day no later than 2 hours after the market closes in local time.",
      "Coverage goes back 20 years in history.",
      "Up to 50 stock quotes can be requested at a time.",
      "Includes open-high-low-close(OCHL) & adjusted close stock prices and volume.",
      "Corporate actions for splits, dividends, spinoffs, bonus shares and distributions are back-adjusted."
    ],
    base_url: "https://api.unibit.ai/v2/stock/historical/",
    template_urls: [
      "https://api.unibit.ai/v2/stock/historical?tickers={{ticker list}}&interval={{a positive number}}&selectedFields={{field list}}&startDate={{YYYY-MM-DD}}&endDate={{YYYY-MM-DD}}&dataType={{json or csv}}&accessKey={{your key}}"
    ],
    example_urls: [
      "https://api.unibit.ai/v2/stock/historical?tickers=AAPL,WORK&interval=1&startDate=2019-09-15&endDate=2019-09-20&selectedFields=all&accessKey=Demo",
      "https://api.unibit.ai/v2/stock/historical?tickers=AAPL&selectedFields=all&startDate=2019-09-15&endDate=2019-09-20&dataType=json&accessKey=Demo"
    ],
    csv_urls: [
      "https://api.unibit.ai/v2/stock/historical?tickers=AAPL,WORK&selectedFields=all&startDate=2019-09-15&endDate=2019-09-20&dataType=csv&accessKey=Demo"
    ],

    input_params: {
      query_params: {
        description: "",
        table_header: input_param_table_header,
        table_data: [
          tickers_default_data.table_data,
          [
            "interval",
            "Optional",
            "A positive number (n, unit: days). If passed, chart data will return every nth element in a date range. Default is 1."
          ],
          [
            "startDate",
            "Optional",
            'Choose the start date (in "YYYY-MM-DD" Format). Ex. "2019-08-25". Default is the most recent trading date. Time is in UTC.'
          ],
          [
            "endDate",
            "Optional",
            'Choose the end date (in "YYYY-MM-DD" Format). Ex. "2019-08-30". Default is the most recent trading date. Time is in UTC.'
          ],
          [
            "seletedFields",
            "Optional",
            'Choose a list (comma separated) of data fields (in snake case) to return. Default is "all".'
          ],
          data_type_param,
          access_key_param
        ]
      }
    },
    response_params: {
      meta_data: {
        ticker: "AAPL",
        date: "02/02/2020",
        range: "1 month",
        interval: 1
      },
      description: "",
      table_header: response_param_table_header,
      table_data: [
        ["data", "String", "Return date"],
        ["open", "Number", "Returns open price for the stock when market opens"],

        ["high", "Number", "Returns intraday highest price for the stock in a market trading day"],
        ["low", "Number", "Returns intraday lowest price for the stock in a market trading day"],
        ["close", "Number", "Returns close price for the stock when market closes"],
        [
          "adj_close",
          "Number",
          "Returns close price for the stock adjusted for splits, and dividends and new shares offering"
        ],
        ["volume", "Nubmer", "Returns trading volume for a day"]
      ]
    }
  },

  // "Stock Technical Indicators": {
  //     api_category: v2_api_category[1],
  //     costs: ["1 credit per data point"],
  //     description: [
  //         "Stock Technical indicators APIs offer mathematical calculations derived from the price, volume, open, high, low data points of a security. Through studying the pattern of technical indicator trendline, traders can make a prediction of the price and stock market movement."
  //     ],
  //     feature: [
  //         "Daily updated for 70,000 stocks",
  //         "Includes 23 technical indicators: SMA, EMA, RSI, WMA, MMA, DoubleEMA, TripleEMA, ZLEMA, UlcerIndex, ROC, HMA, CMO, StochasticRSI, VWAP, ADX, CCI, StochasticOscillatorK, AROONDOWN, AROONUP, WilliamsR, RWLow, RWIHigh and DPO",
  //         "Returns technical indicators value for the stock"
  //     ],
  //     base_url: "https://api.unibit.ai/v2/stock/technicalIndicator/",
  //     template_urls: [
  //         "https://api.unibit.ai/v2/stock/technicalIndicator?tickers={{ticker list}}&function={{see possible options}}&interval={{day month or year}}&selectedFields={{field list}}&startDate={{YYYY-MM-DD}}&endDate={{YYYY-MM-DD}}&dataType={{json or csv}}&accessKey={{your key}}"
  //     ],
  //     example_urls: [
  //         "https://api.unibit.ai/v2/stock/technicalIndicator?tickers=AAPL&function=SMA&intervalFrequency=month&startDate=2019-08-25&endDate=2019-08-30&dataType=json&accessKey=Demo"
  //     ],
  //     csv_urls: [
  //         "https://api.unibit.ai/v2/stock/technicalIndicator?tickers=AAPL&function=SMA&intervalFrequency=month&startDate=2019-08-25&endDate=2019-08-30&dataType=csv&accessKey=Demo"
  //     ],
  //     possible_options: {
  //         description: "",
  //         table_header: ["Function", "Requirement", "Description"],
  //         table_data: [
  //             [
  //                 "SMA",
  //                 "dataPoints, seriesType, intervalFrequency",
  //                 "requires these 3 input parameters"
  //             ],
  //             [
  //                 "EMA",
  //                 "dataPoints, seriesType, intervalFrequency",
  //                 "requires these 3 input parameters"
  //             ],
  //             [
  //                 "RSI",
  //                 "dataPoints, seriesType, intervalFrequency",
  //                 "requires these 3 input parameters"
  //             ],
  //             [
  //                 "WMA",
  //                 "dataPoints, seriesType, intervalFrequency",
  //                 "requires these 3 input parameters"
  //             ],
  //             [
  //                 "MMA",
  //                 "dataPoints, seriesType, intervalFrequency",
  //                 "requires these 3 input parameters"
  //             ],
  //             [
  //                 "DoubleEMA",
  //                 "dataPoints, seriesType, intervalFrequency",
  //                 "requires these 3 input parameters"
  //             ],
  //             [
  //                 "TripleEMA",
  //                 "dataPoints, seriesType, intervalFrequency",
  //                 "requires these 3 input parameters"
  //             ],
  //             [
  //                 "ZLEMA",
  //                 "dataPoints, seriesType, intervalFrequency",
  //                 "requires these 3 input parameters"
  //             ],
  //             [
  //                 "UlcerIndex",
  //                 "dataPoints, seriesType, intervalFrequency",
  //                 "requires these 3 input parameters"
  //             ],
  //             [
  //                 "ROC",
  //                 "dataPoints, seriesType, intervalFrequency",
  //                 "requires these 3 input parameters"
  //             ],
  //             [
  //                 "HMA",
  //                 "dataPoints, seriesType, intervalFrequency",
  //                 "requires these 3 input parameters"
  //             ],
  //             [
  //                 "CMO",
  //                 "dataPoints, seriesType, intervalFrequency",
  //                 "requires these 3 input parameters"
  //             ],
  //             [
  //                 "StochasticRSI",
  //                 "dataPoints, seriesType, intervalFrequency",
  //                 "requires these 3 input parameters"
  //             ],
  //             ["VWAP", "dataPoints, intervalFrequency", "requires these 2 input parameters"],
  //             ["ADX", "dataPoints, intervalFrequency", "requires these 2 input parameters"],
  //             ["CCI", "dataPoints, intervalFrequency", "requires these 2 input parameters"],
  //             [
  //                 "StochasticOscillatorK",
  //                 "dataPoints, intervalFrequency",
  //                 "requires these 2 input parameters"
  //             ],
  //             [
  //                 "ARRONDOWN",
  //                 "dataPoints, intervalFrequency",
  //                 "requires these 2 input parameters"
  //             ],

  //             [
  //                 "ARROONUP",
  //                 "dataPoints, intervalFrequency",
  //                 "requires these 2 input parameters"
  //             ],
  //             [
  //                 "WilliamR",
  //                 "dataPoints, intervalFrequency",
  //                 "requires these 2 input parameters"
  //             ],
  //             [
  //                 "RWILow",
  //                 "dataPoints, intervalFrequency",
  //                 "requires these 2 input parameters"
  //             ],
  //             [
  //                 "RWIHigh",
  //                 "dataPoints, intervalFrequency",
  //                 "requires these 2 input parameters"
  //             ],
  //             ["DPO", "dataPoints, intervalFrequency", "requires these 2 input parameters"],
  //             ["ATR", "dataPoints, intervalFrequency", "requires these 2 input parameters"],
  //             [
  //                 "MACD",
  //                 "seriesType, intervalFrequency",
  //                 "requires these 2 input parameters"
  //             ],
  //             [
  //                 "BBANDSM",
  //                 "seriesType, intervalFrequency",
  //                 "requires these 2 input parameters"
  //             ],
  //             [
  //                 "KAMA",
  //                 "seriesType, intervalFrequency",
  //                 "requires these 2 input parameters"
  //             ],
  //             ["PPO", "seriesType, intervalFrequency", "requires these 2 input parameters"],
  //             [
  //                 "CoppockCurve",
  //                 "seriesType, intervalFrequency",
  //                 "requires these 2 input parameters"
  //             ],
  //             ["OBV", "intervalFrequency", "requires these 1 input parameters"],
  //             ["ParabolicSar", "intervalFrequency", "requires these 1 input parameters"],
  //             ["Fisher", "intervalFrequency", "requires these 1 input parameters"],
  //             [
  //                 "ChandelierExitShort",
  //                 "intervalFrequency",
  //                 "requires these 1 input parameters"
  //             ],
  //             [
  //                 "ChandelierExitLong",
  //                 "intervalFrequency",
  //                 "requires these 1 input parameters"
  //             ]
  //         ]
  //     },
  //     input_params: {
  //         query_params: {
  //             description: "",
  //             table_header: input_param_table_header,
  //             table_data: [
  //                 tickers_default_data.table_data,
  //                 [
  //                     "function",
  //                     "Required",
  //                     "Choose from \"SMA, EMA, RSI, WMA, MMA, DoubleEMA, TripleEMA, ZLEMA, UlcerIndex, ROC, HMA, CMO, StochasticRSI, VWAP, ADX, CCI, StochasticOscillatorK, AROONDOWN, AROONUP, WilliamsR, RWLow, RWIHigh, DPO\"."
  //                 ],
  //                 [
  //                     "startDate",
  //                     "Optional",
  //                     "Choose the start date (in \"YYYY-MM-DD\" Format). Ex. \"2019-08-25\". Default is the most recent trading date. Time is in UTC."
  //                 ],
  //                 [
  //                     "endDate",
  //                     "Optional",
  //                     "Choose the end date (in \"YYYY-MM-DD\" Format). Ex. \"2019-08-30\". Default is the most recent trading date. Time is in UTC."
  //                 ],
  //                 [
  //                     "intervalFrequency",
  //                     "Optional",
  //                     "Choose form \"daily, weekly, monthly\" or \"day, week, month\". Default is daily."
  //                 ],

  //                 [
  //                     "datapoint",
  //                     "Optional",
  //                     "Choose from a number of data points for calculating technical indicators. Default is 1."
  //                 ],
  //                 [
  //                     "series_type",
  //                     "Optional",
  //                     "Choose from open, close, high, low. Default is close."
  //                 ],
  //                 [
  //                     "selectedFields",
  //                     "Optional",
  //                     "Choose a list (comma separated) of data fields (in snake case) to return. Default is \"all\"."
  //                 ],
  //                 data_type_param,
  //                 access_key_param
  //             ]
  //         }
  //     },
  //     response_params: {
  //         meta_data: {
  //             ticker: "AAPL",
  //             "Technical Indicator": "SMA"
  //         },
  //         description: "",
  //         table_header: response_param_table_header,
  //         table_data: [
  //             [
  //                 "date",
  //                 "String",
  //                 "Returns date."
  //             ],
  //             [
  //                 "indicator",
  //                 "String",
  //                 "Returns the name of technical indicator."
  //             ],
  //             ["interval", "Required", "Choose from daily, weekly, monthly"],
  //             ["range", "Optional", "Choose from range options above (i.e. 1m)"],
  //             [
  //                 "datapoint",
  //                 "Required",
  //                 "Choose from a number of data points for calculating technical indicators"
  //             ],
  //             ["series_type", "Required", "Choose from Open, Close, High, Low"],
  //             access_key_param
  //         ]
  //     }
  // },

  "Company Financials": {
    api_category: v2_api_category[1],
    costs: ["100 credit per data point"],
    description: [
      "The Company Financials API offers information covered in financial reports including income statement, balance sheet and cash flow, which reflects company financial details."
    ],

    feature: [
      "This company financial API covers over 39,000+ companies traded in major exchanges.",
      "This API is updated based on the company’s earnings announcement and quarterly financial reports.",
      "Historical financial statements, including balance sheets, income statements and cash flow statement, covers 5 years of data.",
      "To get a full list of companies that we cover, please checkout Stock Coverage API in the Reference API section."
    ],
    base_url: "https://api.unibit.ai/v2/company/coreFinancials/",
    template_urls: [
      "https://api.unibit.ai/v2/company/coreFinancials?tickers={{ticker list}}&interval={{A, Q or TTM}}&statement={{see possible options}}&startDate={{YYYY-MM-DD}}&endDate={{YYYY-MM-DD}}&selectedFields={{field list}}&dataType={{json or csv}}&accessKey={{your key}}"
    ],
    example_urls: [
      "https://api.unibit.ai/v2/company/coreFinancials?tickers=AAPL,WORK&statement=BS&startDate=2019-01-01&endDate=2020-01-01&interval=A&accessKey=Demo",
      "https://api.unibit.ai/v2/company/coreFinancials?tickers=AAPL&statement=IS&selectedFields=total_revenue,net_income&startDate=2019-06-30&endDate=2020-02-01&interval=Q&accessKey=Demo"
    ],
    csv_urls: [
      "https://api.unibit.ai/v2/company/coreFinancials?tickers=AAPL&statement=CF&selectedFields=all&startDate=2019-12-31&endDate=2020-01-01&interval=TTM&dataType=csv&accessKey=Demo"
    ],
    possible_options: {
      description: "",
      table_header: ["Financials Type", "Frequency", "Description"],
      table_data: [
        [
          "Income Statement (IS)",
          "Annual (A), Quarterly (Q), or Trailing 12 Month (TTM)",
          "Company’s income statement"
        ],
        [
          "Balance Sheet (BS)",
          'Annual (A), Quarterly (Q), or Trailing 12 Month"(TTM)',
          "Company’s balance sheet"
        ],
        [
          "Cash Flow (CF)",
          "Annual (A), Quarterly (Q), or Trailing 12 Month (TTM)",
          "Company’s cash flow statement"
        ]
      ]
    },
    input_params: {
      query_params: {
        description: "",
        table_header: input_param_table_header,
        table_data: [
          tickers_default_data.table_data,
          [
            "interval",
            "Optional",
            'Choose from "A" (Annual), "Q" (Quarterly), or "TTM" (Trailing 12 Month). Default is A (Annual).'
          ],
          [
            "statement",
            "Optional",
            'Choose from "IS" (Income Statement), "BS" (Balance Sheet), or "CF" (Cash Flow). Default is "IS".'
          ],
          [
            "startDate",
            "Required",
            'Choose the start date (in "YYYY-MM-DD" Format). Ex."2019-08-25". Time is in UTC.'
          ],
          [
            "endDate",
            "Required",
            'Choose the end date (in "YYYY-MM-DD" Format). Ex."2019-08-25". Time is in UTC.'
          ],
          [
            "selectedFields",
            "Optional",
            'Choose a list (comma separated) of data fields (in snake case) to return. Default is "all".'
          ],
          data_type_param,
          access_key_param
        ]
      }
    },
    response_params: {
      description:
        "For example, income statement response looks like this (all numbers are in thousands in local currency):",
      table_header: response_param_table_header,
      table_data: [
        ["total_revenue", "String", "Return total revenue produced by a company."],
        ["operating_expense", "String", "Return operating expense."],
        ["gross_profit", "String", "Return gross profit produced by a company."],
        ["interest_expense", "String", "Return interest expense incurred by a company."],
        [
          "selling_general_and_administration",
          "String",
          "Return selling general and administration."
        ],
        ["gross_profit", "String", "Return gross profit produced by a company."],
        ["income_before_tax", "String", "Return income before tax."],
        ["basic_eps", "String", "Return the basic earnings per share."],
        ["income_tax_expenses", "String", "Return income tax expenses."],
        ["other_income_expense_net", "String", "Return other income expense net."],
        ["cost_of_revenue", "String", "Return cost of revenue produced by a company."],
        ["operating_income_or_loss", "String", "Return operating income or loss."],
        ["net_income_continuous_operations", "String", "Return net income continuous operations."],
        ["basic_average_shares", "String", "Return the basic average shares."],
        ["diluted_average_shares", "String", "Return diluted average shares."],
        ["diluted_eps", "String", "Return diluted earnings per share."],
        ["net_income", "String", "Return net income produced by a company."],
        ["net_income_common_stockholders", "String", "Return net income common stockholders."],
        ["research_and_development", "String", "Return research and development."]
      ]
    }
  },

  "Company Profile": {
    api_category: v2_api_category[1],
    costs: ["10 credit per data point"],
    description: [
      "The company profile API returns a snippet of basic information about a company, including its name, industry, website, description, leadership sector and asset type. This API lays a foundation for our data coverage across different subjects. You may use this API to build an asset registry database. Currently, profile and description for ETFs and other derivatives are not supported."
    ],
    feature: [
      "This API covers over 36,000+ companies traded in major exchanges around the globe.",
      "This api is updated quarterly.",
      "Requested by company ticker."
    ],
    base_url: "https://api.unibit.ai/v2/company/profile/",
    template_urls: [
      "https://api.unibit.ai/v2/company/profile?tickers={{ticker list}}&selectedFields={{field list}}&dataType={{json or csv}}&accessKey={{your key}}"
    ],
    example_urls: [
      "https://api.unibit.ai/v2/company/profile?tickers=AAPL&selectedFields=all&accessKey=Demo"
    ],
    csv_urls: [
      "https://api.unibit.ai/v2/company/profile?tickers=AAPL&selectedFields=all&dataType=csv&accessKey=Demo"
    ],
    input_params: {
      query_params: {
        description: "",
        table_header: input_param_table_header,
        table_data: [
          tickers_default_data.table_data,
          [
            "selectedFields",
            "Optional",
            'Choose a list (comma separated) of data fields (in snake case) to return. Default is "all".'
          ],

          data_type_param,
          access_key_param
        ]
      }
    },
    response_params: {
      meta_data: {
        datapoints: 1,
        ticker: "AMZN",
        "credit cost": 100,
        "Time Zone": "America/New_York",
        "last refreshed": "06/10/2019 at 03:25PM ET"
      },
      description: "",
      table_header: response_param_table_header,
      table_data: [
        ["ticker", "String", "Returns selected company’s ticker."],
        ["company_name", "String", "Returns selected company’s name."],
        ["address", "String", "Return address of the selected company."],
        ["phone", "String", "Returns selected company’s phone."],
        ["website", "String", "Returns selected company’s website."],
        ["sector", "String", "Returns selected company security’s sector."],
        ["industry", "String", "Returns selected company’s industry."],
        ["employee_number", "String", "Returns selected company’s employee number."],
        ["executive1_name", "String", "Returns selected company’s executive1 name."],
        ["executive1_title", "String", "Returns selected company’s executive1 title."],
        ["executive1_pay", "String", "Returns selected company’s executive1 pay."],
        ["executive1_exercised", "String", "Returns selected company’s executive1 exercised."],
        ["executive1_yearborn", "String", "Returns selected company’s executive1 yearborn."],
        ["executive2_name", "String", "Returns selected company’s executive2 name."],
        ["executive2_title", "String", "Returns selected company’s executive2 title."],
        ["executive2_pay", "String", "Returns selected company’s executive2 pay."],
        ["executive2_exercised", "String", "Returns selected company’s executive2 exercised."],
        ["executive2_yearborn", "String", "Returns selected company’s executive2 yearborn."],
        ["executive3_name", "String", "Returns selected company’s executive3 name."],
        ["executive3_title", "String", "Returns selected company’s executive3 title."],
        ["executive3_pay", "String", "Returns selected company’s executive3 pay."],
        ["executive3_exercised", "String", "Returns selected company’s executive3 exercised."],
        ["executive3_yearborn", "String", "Returns selected company’s executive3 yearborn."],
        ["executive4_name", "String", "Returns selected company’s executive4 name."],
        ["executive4_title", "String", "Returns selected company’s executive4 title."],
        ["executive4_pay", "String", "Returns selected company’s executive4 pay."],
        ["executive4_exercised", "String", "Returns selected company’s executive4 exercised."],
        ["executive4_yearborn", "String", "Returns selected company’s executive4 yearborn."],
        ["executive5_name", "String", "Returns selected company’s executive5 name."],
        ["executive5_title", "String", "Returns selected company’s executive5 title."],
        ["executive5_pay", "String", "Returns selected company’s executive5 pay."],
        ["executive5_exercised", "String", "Returns selected company’s executive5 exercised."],
        ["executive5_yearborn", "String", "Returns selected company’s executive5 yearborn."],
        ["company_decription", "String", "Returns selected company’s description."]
      ]
    }
  },

  "Company Financial Summary": {
    api_category: v2_api_category[1],
    costs: ["10 credit per data point"],
    description: [
      "Company Financial Summary includes a timely financial summary for listed companies around the globe. The API supports important financial indicators such as Market Capitalization, Dividend Yield, Price to Earning Ratios and many more."
    ],
    feature: [
      "This API covers up to 70,000 companies traded in major exchanges.",
      "This API is updated every day.",
      "Include important financial indicators such as Market Capitalization, Dividend Yield, and P/E ratio.",
      "To get a full list of companies that we cover, you may use the API here."
    ],
    base_url: "https://api.unibit.ai/v2/company/financialSummary/",
    template_urls: [
      "https://api.unibit.ai/v2/company/financialSummary?tickers={{ticker list}}&selectedFields={{field list}}&dataType={{json or csv}}&accessKey={{your key}}"
    ],
    example_urls: [
      "https://api.unibit.ai/v2/company/financialSummary?tickers=AAPL,WORK&selectedFields=all&accessKey=Demo"
    ],
    csv_urls: [
      "https://api.unibit.ai/v2/company/financialSummary?tickers=AAPL,WORK&selectedFields=all&dataType=csv&accessKey=Demo"
    ],

    input_params: {
      query_params: {
        description: "",
        table_header: input_param_table_header,
        table_data: [
          tickers_default_data.table_data,
          [
            "selectedFields",
            "Optional",
            'Choose a list (comma separated) of data fields (in snake case) to return. Default is "all".'
          ],
          data_type_param,
          access_key_param
        ]
      }
    },
    response_params: {
      meta_data: {
        ticker: "AAPL",
        date: "02/02/2020"
      },
      description: "",
      table_header: response_param_table_header,
      table_data: [
        ["open", "String", "Returns open price for the stock"],
        ["previous_close", "String", "Return previous close price for the stock"],
        ["market_cap", "String", "Returns current market capitalization for the stock"],
        ["forward_dividend_yield", "String", "Returns forward dividend yield for the stock"],
        ["avg_volume", "String", "Returns average volume for the stock"],
        ["ex_dividend_date", "String", "Returns ex-dividend date for the stock"],
        ["beta", "String", "Returns beta for the stock"],
        ["pe_ratio", "String", "Returns Price to Earning ratio for the stock"],
        ["eps", "String", "Returns earning per share for for the stock"],
        ["week_52_range", "String", "Returns 52 week range for the stock"],
        ["earnings_date", "String", "Returns earning date for the stock"],
        ["sentiment", "Number", "Returns sentiment score for the stock"]
      ]
    }
  },

  "Ownership Structure": {
    api_category: v2_api_category[1],
    costs: ["300 credit per data point"],
    description: [
      "Ownership Structure api offers the percentages of institutional owners’ holding position of the selected stocks."
    ],
    feature: [
      "This API covers up to 4,000 companies traded in the major U.S exchanges including NASDAQ, AMEX, NYSE, and ARCA.",
      "This API is updated every week.",
      "This API returns the current ownership structure of based on latest filing.",
      "Ownership type includes Majority Holder, Top Institutional Holder and Mutual Fund Holder."
    ],
    base_url: "https://api.unibit.ai/v2/company/ownership/",
    template_urls: [
      "https://api.unibit.ai/v2/company/ownership?tickers={{ticker list}}&ownershipType={{see possible options}}&startDate={{YYYY-MM-DD}}&endDate={{YYYY-MM-DD}}&selectedFields={{field list}}&dataType={{json or csv}}&accessKey={{your key}}"
    ],
    example_urls: [
      "https://api.unibit.ai/v2/company/ownership?tickers=AAPL,WORK&ownershipType=majority_holder&startDate=2019-09-12&endDate=2019-09-27&selectedFields=all&accessKey=Demo",
      "https://api.unibit.ai/v2/company/ownership?tickers=AAPL&ownershipType=top_institutional_holder&startDate=2019-09-12&endDate=2019-09-27&selectedFields=all&accessKey=Demo"
    ],
    csv_urls: [
      "https://api.unibit.ai/v2/company/ownership?tickers=AAPL,WORK&ownershipType=majority_holder&startDate=2019-09-12&endDate=2019-09-27&selectedFields=all&dataType=csv&accessKey=Demo",
      "https://api.unibit.ai/v2/company/ownership?tickers=AAPL&ownershipType=top_institutional_holder&startDate=2019-09-12&endDate=2019-09-27&selectedFields=all&dataType=csv&accessKey=Demo"
    ],
    possible_options: {
      description: "",
      table_header: ["Ownership Type", "Update Frequency", "Description"],
      table_data: [
        ["majority_holder", "Weekly", "Returns majority owner of a selected company"],
        [
          "top_institutional_holder",
          "Weekly",
          "Returns top institutional owner of a selected company"
        ],
        ["top_mutual_fund_holder", "Weekly", "Returns top mutual fund owner of a selected company"]
      ]
    },
    input_params: {
      query_params: {
        description: "",
        table_header: input_param_table_header,
        data_type_param,
        table_data: [
          tickers_default_data.table_data,
          [
            "ownershipType",
            "Required",
            'Choose from "majority_holder, top_institutional_holder, and top_mutual_fund_holder".'
          ],
          [
            "startDate",
            "Optional",
            'Choose the start date (in "YYYY-MM-DD" Format). Ex. "2019-08-25". Default is the most recent reporting date.Time is in UTC.'
          ],
          [
            "endDate",
            "Optional",
            'Choose the start date (in "YYYY-MM-DD" Format). Ex. "2019-08-25". Default is the most recent reporting date.Time is in UTC.'
          ],
          [
            "selectedFields",
            "Optional",
            'Choose a list (comma separated) of data fields (in snake case) to return. Default is "all".'
          ],
          data_type_param,
          access_key_param
        ]
      }
    },
    response_params: {
      meta_data: {
        ticker: "AAPL",
        date: "02/02/2020"
      },
      description: "Major holders include the ownership percentage of each major institution.",
      table_header: response_param_table_header,
      table_data: [
        ["ticker", "String", "Returns company’s symbol."],
        ["holder_name", "String", "Returns owner's name for the company selected."],
        ["shares", "Number", "Returns owner's shares number for the company selected."],
        ["reported_data", "String", "Returns reported date for the company selected."],
        ["reported_timestamp", "Number", "Returns reported timestamp for the company selected."],
        ["percent_out", "Number", "Returns ownership percentage for the company selected."],
        ["value", "Number", "Returns ownership value in dollars for the company selected."]
      ]
    }
  },

  "Insider Transaction": {
    api_category: v2_api_category[1],
    costs: ["300 credit per data point"],
    description: [
      "The SEC mandates that all public companies' directors, officers, or beneficial owners (ownership larger than 10%) are obligated to disclose their ownership of a public equity, and release their transactions in these equity shares (submitted in Form 4). Purchases, sales, option grants, gifts of stock are important business activities that can influence market. UniBit designs and deploys these information feeds for you and gain instant access to these transactions and build valuable applications."
    ],
    feature: [
      "Cover 5000 U.S companies, historic records go back to 2003.",
      "Exchange covered: NYSE, NASDAQ, NYSEARCA, AMEX.",
      "Updated intraday everyday.",
      "Requested by company ticker.",
      "Includes insider roster, trading value, types and dates information of each transaction."
    ],
    base_url: "https://api.unibit.ai/v2/company/insiderTransaction/",
    template_urls: [
      "https://api.unibit.ai/v2/company/insiderTransaction?tickers={{ticker list}}&startDate={{YYYY-MM-DD}}&endDate={{YYYY-MM-DD}}&size={{a positive number}}&selectedFields={{field list}}&dataType={{json or csv}}&accessKey={{your key}}"
    ],
    example_urls: [
      "https://api.unibit.ai/v2/company/insiderTransaction?tickers=AAPL,WORK&startDate=2019-08-25&endDate=2019-08-30&selectedFields=all&accessKey=Demo"
    ],
    csv_urls: [
      "https://api.unibit.ai/v2/company/insiderTransaction?tickers=AAPL,WORK&startDate=2019-08-25&endDate=2019-08-30&selectedFields=all&dataType=csv&accessKey=Demo"
    ],

    input_params: {
      query_params: {
        description: "",
        table_header: input_param_table_header,
        table_data: [
          tickers_default_data.table_data,
          [
            "startDate",
            "Optional",
            'Choose the start date of the transaction filling date (in "YYYY-MM-DD" format). Ex."2019-08-25". Default is the most recent filing date.'
          ],
          [
            "endDate",
            "Optional",
            'Choose the start date of the transaction filling date (in "YYYY-MM-DD" format). Ex. "2019-08-26". Default is the most recent filing date.'
          ],
          [
            "size",
            "Optional",
            "Set the max number of datapoints to retreive. If not specified, this query returns all insider transactions requested between the time specified. Otherwise, it returns the number (size n) of objects (JSON) or rows (CSV) per ticker. Max is 2,147,483,647."
          ],
          [
            "seletedFields",
            "Optional",
            'Choose a list (comma separated) of data fields (in snake case) to return. Default is "all".'
          ],
          data_type_param,
          access_key_param
        ]
      }
    },
    response_params: {
      meta_data: {
        ticker: "AAPL",
        date: "02/02/2020"
      },
      description: "",
      table_header: response_param_table_header,
      table_data: [
        ["ticker", "String", "Returns the company symbol."],
        ["price", "String", "Return the average purchase price from the insider."],
        [
          "type",
          "String",
          "Returns the type of transaction from the insider either sale/purchase. Purchase (P), Sale (Sale), Grant (A), Sale to Issuer (D), Gift (G), Tax (F), Exercise of Options (M), Exercise of Options (X), Converted Derivative (C), Inherited (W)."
        ],
        ["trade_date", "String", "Returns the exact trade time of the transaction."],
        ["filing_date", "String", "Returns the filing date and time for the transaction."],
        ["trade_type", "String", "Returns the transaction type"],
        ["value", "String", "Returns the total value for the transaction."],
        ["owned", "String", "Returns the total shares owned after the transaction."],
        ["change_own", "String", "Returns the change in percentage after the transaction."],
        ["insider_name", "String", "Returns the insider name for the transaction involved"],
        ["insider_title", "String", "Returns the insider job title for the transaction involved."],
        ["qty", "String", "Returns the number of shares being transacted."]
      ]
    }
  },

  "SEC Filing Link": {
    api_category: v2_api_category[1],
    costs: ["1 credit per data point"],
    description: ["This api returns links to the EDGAR database for listed companies in the U.S."],
    feature: [
      "Coverage goes back to 1993.",
      "This api is updated daily.",
      "Includes txt link, html link and doc link of different types of SEC filings."
    ],

    base_url: "https://api.unibit.ai/v2/company/secFilingLink/",
    template_urls: [
      "https://api.unibit.ai/v2/company/secFilingLink?tickers={{ticker list}}&startDate={{YYYY-MM-DD}}&endDate={{YYYY-MM-DD}}&selectedFields={{field list}}&dataType={{json or csv}}&accessKey={{your key}}"
    ],
    example_urls: [
      "https://api.unibit.ai/v2/company/secFilingLink?tickers=AAPL,WORK&startDate=2019-07-25&endDate=2019-08-30&selectedFields=all&accessKey=Demo"
    ],
    csv_urls: [
      "https://api.unibit.ai/v2/company/secFilingLink?tickers=AAPL,WORK&startDate=2019-07-25&endDate=2019-08-30&selectedFields=all&dataType=csv&accessKey=Demo"
    ],
    input_params: {
      query_params: {
        description: "",
        table_header: input_param_table_header,
        table_data: [
          tickers_default_data.table_data,
          [
            "startDate",
            "Optional",
            'Choose the start date of filing date. Ex. "08/25/2019". Default is the earliest available date.'
          ],
          ["endDate", "Optional", 'Choose the end date of filing date. Ex. "08/26/2019".'],
          [
            "selectedFields",
            "Optional",
            'Choose a list (comma separated) of data fields (in snake case) to return. Default is "all".'
          ],
          data_type_param,
          access_key_param
        ]
      }
    },
    response_params: {
      meta_data: {
        ticker: "AAPL",
        date: "02/02/2020"
      },
      description: "",
      table_header: response_param_table_header,
      table_data: [
        ["cik", "Number", "Returns company’s Central Index Key (CIK)."],
        ["filing_type", "String", 'Returns company’s SEC filing type. Ex."10-Q".'],
        ["date", "String", "Returns company’s filing date."],
        ["txt_url", "String", "Returns company filing’s parsed txt. file."],
        ["html_url", "String", "Returns company filing’s parsed html file."],
        ["doc_url", "String", "Returns company filing's parsed doc file."]
      ]
    }
  },

  "Stock News": {
    api_category: v2_api_category[1],
    costs: ["100 credit per data point"],
    description: [
      "UniBit Stock News API is a single easy-to-use endpoint to obtain the latest, comprehensive, institutional quality corporate and business related news events from trusted sources. What’s unique about UniBit’s news feeds is that each article is analyzed and tagged through Machine Learning model so you may rank, sort, and classify these articles based on sentiment, location, genre etc."
    ],
    feature: [
      "This API covers news for 5,000 public companies on the U.S market (ETF not included). ",
      "Exchange covered: NYSE, NASDAQ, NYSEARCA, AMEX",
      "The news articles go back 1 year in history",
      "Over 1000 financial and business related news publishers are curated",
      "Updated every 30 minutes.",
      "Analyzed through Natural language processing and deep learning to ensure quality and relevance."
    ],
    base_url: "https://api.unibit.ai/v2/company/news/",
    template_urls: [
      "https://api.unibit.ai/v2/company/news?tickers={{ticker list}}&startDate={{YYYY-MM-DD}}&endDate={{YYYY-MM-DD}}&startMinute={{HH:MM:SS}}&endMinute={{HH:MM:SS}}&genre={{see possible options}}&sector={{see possible options}}&selectedFields={{field list}}&dataType={{json or csv}}&accessKey={{your key}}"
    ],
    example_urls: [
      "https://api.unibit.ai/v2/company/news?tickers=AAPL,WORK&genre=partnership&sector=technology&selectedFields=all&accessKey=Demo"
    ],
    csv_urls: [
      "https://api.unibit.ai/v2/company/news?tickers=AAPL&startDate=2019-08-25&endDate=2019-08-30&startMinute=10:00:00&endMinute=11:00:00&genre=partnership&sector=technology&selectedFields=all&dataType=csv&accessKey=Demo"
    ],
    input_params: {
      query_params: {
        description: "",
        table_header: input_param_table_header,
        table_data: [
          tickers_default_data.table_data,
          [
            "startDate",
            "Optional",
            'Choose the start date (in "YYYY-MM-DD" Format). Ex. 2019-08-25". Default is yesterday. Time is in UTC.'
          ],
          [
            "endDate",
            "Optional",
            'Choose the end date (in "YYYY-MM-DD" Format). Ex. "2019-08-26". Default is yesterday. Time is in UTC.'
          ],
          [
            "startMinute",
            "Optional",
            'Choose the specific intraday period (in "HH:MM:SS" format). Ex. "11:00:00". Default time is "00:00:00". Time is in UTC.'
          ],
          [
            "endMinute",
            "Optional",
            'Choose the specific intraday period (in "HH:MM:SS" format). Ex. "12:00:00". Default time is "23:59:59". Time is in UTC.'
          ],
          [
            "size",
            "optional",
            "Set the max number of datapoints to retreive. If not specified, this query returns all news requested between the time specified. Otherwise, it returns the number (size n) of objects (JSON) or rows (CSV) per ticker. Max is 2,147,483,647."
          ],
          ["genre", "Optional", 'Choose the genres (multiple choice). Default is "all".'],
          [
            "sector",
            "Optional",
            'Choose from "healthcare, energy, basic materials, industrials, technology, financial services, communication services, consumer cyclical, consumer defensive, utilities, real estate" (multiple choice). Default is "all".'
          ],
          [
            "selectedFields",
            "Optional",
            'Choose a list (comma separated) of data fields (in snake case) to return. Default is "all".'
          ],
          data_type_param,
          access_key_param
        ]
      }
    },
    response_params: {
      meta_data: {
        ticker: "AAPL",
        date: "02/02/2020"
      },
      description: "",
      table_header: response_param_table_header,
      table_data: [
        ["date", "Number", "Returns the date for the news"],
        ["time", "Number", "Returns the time for the news"],
        ["ticker", "String", "Returns company ticker"],
        ["title", "String", "Returns news headlines related to the selected company ticker"],
        [
          "author",
          "String",
          "Returns news author, contribute related to the selected company ticker"
        ],
        [
          "description",
          "String",
          "Returns news article summary related to the selected company ticker"
        ],
        ["url", "String", "Returns news article web URL related to the selected company ticker"],
        ["source", "String", "Returns the source of the news article"],
        ["published_at", "String", "Return original publish time for the news article"],
        ["sector", "String", "Returns industry sector related to the article"],
        ["genre", "String", "Event classification predicted through deep learning"],
        [
          "sentiment",
          "Number",
          "Returns sentiment score from -1 to 1 based on news content for the selected company ticker"
        ]
      ]
    }
  },

  "Corporate Splits": {
    api_category: v2_api_category[1],
    costs: ["100 credit per data point"],
    description: [
      "UniBit offers Stock Splits and Reverse Stock Splits calendar of global listed company. Stock split is a corporate action in which a company divides its existing shares into multiple shares to boost the liquidity of the shares. On the opposite, reverse stock split is to decrease its outstanding share number based on a predetermined ratio to prevent stocks from being delisted or other strategic purposes."
    ],
    feature: [
      "Earliest splits record available from 2016.",
      "Splits calendar for the next 4 months available",
      "Update frequency: Everyday",
      "Request by time range",
      "Updated every 30 minutes.",
      "Support tickers search."
    ],
    base_url: "https://api.unibit.ai/v2/company/actions/splits/",
    template_urls: [
      "https://api.unibit.ai/v2/company/actions/splits?tickers={{ticker list}}&startDate={{YYYY-MM-DD}}&endDate={{YYYY-MM-DD}}&size={{a positive number}}&selectedFields={{field list}}&dataType={{json or csv}}&accessKey={{your key}}"
    ],
    example_urls: [
      "https://api.unibit.ai/v2/company/actions/splits?tickers=all&startDate=2019-02-01&endDate=2019-02-11&selectedFields=all&accessKey=Demo"
    ],
    csv_urls: [
      "https://api.unibit.ai/v2/company/actions/splits?tickers=all&startDate=2019-02-01&endDate=2019-02-11&dataType=csv&accessKey=Demo"
    ],
    input_params: {
      query_params: {
        description: "",
        table_header: input_param_table_header,
        table_data: [
          [
            "tickers",
            "Optional",
            'Choose the symbol of a company. Please visit Stock Coverage API for all the ticker that we support. Multiple tickers are supported. Seperate tickers with comma such as "AAPL,WORK".'
          ],
          [
            "startDate",
            "Required",
            'Choose the start date (in "YYYY-MM-DD" Format). Ex. "2019-08-25". Time is in UTC.'
          ],
          [
            "endDate",
            "Required",
            'Choose the end date (in "YYYY-MM-DD" Format). Ex. "2019-08-26". Time is in UTC.'
          ],
          [
            "size",
            "Optional",
            "Set the max number of datapoints to retreive. If not specified, this query returns all split actions requested between the time specified. Otherwise, it returns the number (size n) of objects (JSON) or rows (CSV). Max is 2,147,483,647."
          ],
          [
            "selectedFields",
            "Optional",
            'Choose a list (comma separated) of data fields (in snake case) to return. Default is "all".'
          ],
          data_type_param,
          access_key_param
        ]
      }
    },
    response_params: {
      meta_data: {
        ticker: "AAPL",
        date: "02/02/2020"
      },
      description: "",
      table_header: response_param_table_header,
      table_data: [
        ["ticker", "String", "Ticker of the company"],
        ["company_name", "String", "Company name of the security"],
        ["payable_on", "String", "Record date of stock spilts"],
        ["optionable", "String", "Whether the stock has option"],
        ["after_split", "String", "Nominator of split ratio or reverse split ratio"],
        ["before_split", "String", "Denominator of split ratio or reverse split ratio"],
        ["timestamp", "Number", 'Timestamp of the "Payable On" on']
      ]
    }
  },

  "Corporate Dividends": {
    api_category: v2_api_category[1],
    costs: ["100 credit per data point"],
    description: [
      "UniBit offers Dividends calendar of worldwide listed companies worldwide. Dividend issuance is a corporate action in which a company divides its earnings and distributes to shareholders."
    ],
    feature: [
      "Earliest splits record available from 05/01/2019",
      "Dividends calendar for the next 3 months available",
      "Update frequency: Everyday",
      "Request by time range",
      "Support search by ticker"
    ],
    base_url: "https://api.unibit.ai/v2/company/actions/dividends/",
    template_urls: [
      "https://api.unibit.ai/v2/company/actions/dividends?tickers={{ticker list}}&startDate={{YYYY-MM-DD}}&endDate={{YYYY-MM-DD}}&size={{a positive number}}&selectedFields={{field list}}&dataType={{json or csv}}&accessKey={{your key}}"
    ],
    example_urls: [
      "https://api.unibit.ai/v2/company/actions/dividends?startDate=2019-08-16&endDate=2019-08-20&accessKey=Demo"
    ],
    csv_urls: [
      "https://api.unibit.ai/v2/company/actions/dividends?startDate=2019-08-16&endDate=2019-08-20&dataType=csv&accessKey=Demo"
    ],
    input_params: {
      query_params: {
        description: "",
        table_header: input_param_table_header,
        table_data: [
          [
            "tickers",
            "Optional",
            'Choose the symbol of a company. Please visit Stock Coverage API for all the ticker that we support. Multiple tickers are supported. Seperate tickers with comma such as "AAPL,WORK".'
          ],
          [
            "startDate",
            "Required",
            'Choose the start date (in "YYYY-MM-DD" Format). Ex. "2019-08-25". Time is in UTC.'
          ],
          [
            "endDate",
            "Required",
            'Choose the end date (in "YYYY-MM-DD" Format). Ex. "2019-08-26". Time is in UTC.'
          ],
          [
            "size",
            "Optional",
            "Set the max number of datapoints to retreive. If not specified, this query returns all split actions requested between the time specified. Otherwise, it returns the number (size n) of objects (JSON) or rows (CSV). Max is 2,147,483,647."
          ],
          [
            "selectedFields",
            "Optional",
            'Choose a list (comma separated) of data fields (in snake case) to return. Default is "all".'
          ],
          data_type_param,
          access_key_param
        ]
      }
    },
    response_params: {
      meta_data: {
        ticker: "AAPL",
        date: "02/02/2020"
      },
      description: "",
      table_header: response_param_table_header,
      table_data: [
        ["ticker_symbol", "String", "Ticker symbol."],
        ["company_name", "String", "Company name of the security."],
        [
          "ex_divident_date",
          "String",
          "Date on or after which security is traded without a previously declared dividend."
        ],
        [
          "ex_divident_timestamp",
          "Integer",
          "Timestamp on or after which security is traded without a previously declared dividend."
        ],
        ["dividend", "Float", "Amount in local currency."],
        [
          "type",
          "String",
          "Frequency (monthly, quarterly, semi-annual, annual, trailing twelve months)."
        ],
        ["payment_date", "String", "Date shareholders expected to receive dividend payment."],
        [
          "payment_timestamp",
          "Integer",
          "Timestamp shareholders expected to receive dividend payment."
        ],
        ["yield_percent", "Float", "Annualized dividend payment to share price in percentage."]
      ]
    }
  },

  "Stock Analyst Ratings": {
    api_category: v2_api_category[1],
    costs: ["1k credit per data point"],
    description: [
      "Stock Analyst Rating API provides daily actions performed by major financial institutions such as Citigroup, Bank of America, UBS group etc. The actions include ratings and price targets for over 3000+ U.S companies. This data feed can be used for measuring market impact and trading signals."
    ],
    feature: [
      "Earliest analyst actions date back 7 years",
      "Update frequency: Daily",
      "Request by time range",
      "Support multi-ticker search"
    ],
    base_url: "https://api.unibit.ai/v2/analytics/us/",
    template_urls: [
      "https://api.unibit.ai/v2/analytics/us?tickers={{ticker list}}&startDate={{YYYY-MM-DD}}&endDate={{YYYY-MM-DD}}&size={{a positive number}}&selectedFields={{field list}}&dataType={{json or csv}}&accessKey={{your key}}"
    ],
    example_urls: [
      "https://api.unibit.ai/v2/analytics/us?tickers=AAPL&startDate=2020-01-02&endDate=2020-01-03&accessKey=demo"
    ],
    csv_urls: [
      "https://api.unibit.ai/v2/analytics/us?tickers=AAPL&startDate=2020-01-02&endDate=2020-01-03&dataType=csv&accessKey=demo"
    ],
    input_params: {
      query_params: {
        description: "",
        table_header: input_param_table_header,
        table_data: [
          tickers_optional_data.table_data,
          [
            "startDate",
            "Optional",
            'Choose the start date (in "YYYY-MM-DD" Format). Ex. "2019-08-25". Default date is today.(Exchange market local time) '
          ],
          [
            "endDate",
            "Optional",
            'Choose the end date (in "YYYY-MM-DD" Format). Ex. "2019-08-30". Default date is today.(Exchange market local time) '
          ],
          [
            "size",
            "Optional",
            "Set the max number of datapoints to retreive. If not specified, this query returns all avaliable datapoints requested between the time specified. Otherwise, it returns the number (size n) of objects (JSON) or rows (CSV) per ticker. Max is 9,999,999."
          ],
          [
            "selectedFields",
            "Optional",
            'Choose a list (comma separated) of data fields (in snake case) to return. Default is "all".'
          ],
          data_type_param,
          access_key_param
        ]
      }
    },
    response_params: {
      meta_data: {
        ticker: "AAPL",
        date: "02/02/2020"
      },
      description: "",
      table_header: response_param_table_header,
      table_data: [
        ["ticker", "String", "Returns the symbol of a company or companies"],
        [
          "date",
          "String",
          "Returns the date when the report is published. Date format is: yyyy-mm-dd"
        ],
        ["company_name", "String", "Returns selected company’s name"],
        ["action", "String", "Action performed by analyst"],
        ["current_price", "String", "Latest Price of the security"],

        ["target_price", "String", "Price provided by the analyst"],
        ["rating", "String", "Rating provided by the analyst"],
        ["timestamp", "Number", "Returns the timestamp when the report is published"]
      ]
    }
  },

  /**
   * Futures & Commodities APIs
   */
  "Realtime Futures and Commodities Price": {
    api_category: v2_api_category[1],
    costs: ["available upon request"],
    description: [
      "This API provides Futures & Commodities data from major exchanges. It covers over 15 unique commodities such as WTI crude oil, gold and silver, and 50 major indices. This API offers Server-Sent Events (SSE) and WebSocket for realtime streaming upon request."
    ],
    feature: [
      "Cover over 12 exchanges including ICE, COMEX, CBOT, NYMEX, LME",
      "Cover major commodities such as Agriculture, Energy, Metals and Indices",
      "Agricultural Futures: Corn, soybean, oat, wheat, coffee, cotton, cocoa, and etc.",
      "Energy Futures: crude oil, brent crude oil, natural gas, gasoline, and natural gas.",
      "Metal Futures: gold, silver, platinum, palladium, aluminum, copper, nickel, zinc, and tin.",
      "Financial Futures: stock indices and currencies.",
      "Price quotes have no delay.",
      "Support RESTful API (JSON & CSV) and SSE (Server-Sent Events)"
    ],
    input_params: {
      query_params: {
        description: "",
        table_header: input_param_table_header,
        table_data: [
          symbols_default_data.table_data,
          [
            "startDate",
            "Optional",
            'Choose the start date (in "YYYY-MM-DD" Format). Ex. "2019-08-25". Real time stock prices go back 1 week. Default date is today.(US Exchange market local time) '
          ],
          [
            "endDate",
            "Optional",
            'Choose the end date (in "YYYY-MM-DD" Format). Ex. "2019-08-30". Real time stock prices only go back 1 week. Default date is today.(US Exchange market local time) '
          ],
          [
            "startMinute",
            "Optional",
            'Choose the specific intraday period (in "HH:MM:SS" format). Ex. "11:00:00". Default time is "00:00:00". (US Exchange market local time)'
          ],
          [
            "endMinute",
            "Optional",
            'Choose the specific intraday period (in "HH:MM:SS" format). Ex. "12:00:00". Default time is "23:59:59". (US Exchange market local time)'
          ],
          [
            "size",
            "Optional",
            "Set the max number of datapoints to retreive. If not specified, this query returns all avaliable datapoints requested between the time specified. Otherwise, it returns the number (size n) of objects (JSON) or rows (CSV) per ticker. Max is 10,000."
          ],
          [
            "selectedFields",
            "Optional",
            'Choose a list (comma separated) of data fields (in snake case) to return. Default is "all".'
          ],
          data_type_param,
          access_key_param
        ]
      }
    },
    response_params: {
      description: "",
      table_header: response_param_table_header,
      table_data: [
        ["symbol", "String", "Returns the symbol of a future or commodity"],
        [
          "date",
          "String",
          "Returns the date realtime price is traded on. Date format is: yyyy-mm-dd"
        ],
        [
          "minute",
          "String",
          "Returns the minute realtime price is traded on. Minute format is: hh:mm"
        ],
        [
          "latest_price",
          "Number",
          'Returns the latest intraday price for the selected future or commodity. Ex: "123.45"'
        ],
        [
          "last_trade_volume",
          "Number",
          'Returns the last intraday trade volume for the selected future or commodity. Ex: "123"'
        ],
        [
          "volume",
          "Number",
          'Returns the aggregated intraday trade volume for the selected future or commodity. Ex: "123"'
        ],
        [
          "price_change_ratio",
          "Number",
          'Returns the intraday price change ratio for the selected future or commodity. Ex: "-0.23"'
        ],
        [
          "last_close",
          "Number",
          'Returns the close price from the last trading day for the selected future or commodity. Ex: "123.45"'
        ],
        [
          "open",
          "Number",
          'Returns the open price from the last trading day for the selected future or commodity. Ex: "123.45"'
        ],
        [
          "high",
          "Number",
          'Returns the high price from the last trading day for the selected future or commodity. Ex: "123.45"'
        ],
        [
          "low",
          "Number",
          'Returns the low price from the last trading day for the selected future or commodity. Ex: "123.45"'
        ],
        [
          "price_2",
          "Number",
          'Returns the 52 week high price for the selected future or commodity. Ex: "123.45"'
        ],
        [
          "price_3",
          "Number",
          'Returns the 52 week low price for the selected future or commodity. Ex: "123.45"'
        ],
        ["timestamp", "Number", "Returns the timestamp of the price is traded on"],
        ["bid(1-5)", "Number", "Returns the price for the security is purchased at"],
        ["bid_size(1-5)", "Number", "Returns the quantities being purchased"],
        ["ask(1-5)", "Number", "Returns the lowest acceptable price for the security"],
        ["ask_size(1-5)", "Number", "Returns the requested price for the security"]
      ]
    }
  },

  "Historical Futures and Commodities Price": {
    api_category: v2_api_category[1],
    costs: ["available upon request"],
    description: [
      "This API offers EOD prices for active futures and commodities trading around the globe in the past 20 years."
    ],
    feature: [
      "Cover over 12 exchanges including ICE, COMEX, CBOT, NYMEX, LME",
      "Cover major commodities such as Agriculture, Energy, Metals and Indices",
      "Agricultural Futures: Corn, soybean, oat, wheat, coffee, cotton, cocoa, and etc.",
      "Energy Futures: crude oil, brent crude oil, natural gas, gasoline, and natural gas.",
      "Metal Futures: gold, silver, platinum, palladium, aluminum, copper, nickel, zinc, and tin.",
      "Financial Futures: stock indices and currencies.",
      "Price quotes are update every day."
    ],
    input_params: {
      query_params: {
        description: "",
        table_header: input_param_table_header,
        table_data: [
          symbols_default_data.table_data,
          [
            "startDate",
            "Optional",
            'Choose the start date (in "YYYY-MM-DD" Format). Ex. "2019-08-25". Real time stock prices go back 1 week. Default date is today.(US Exchange market local time) '
          ],
          [
            "endDate",
            "Optional",
            'Choose the end date (in "YYYY-MM-DD" Format). Ex. "2019-08-30". Real time stock prices only go back 1 week. Default date is today.(US Exchange market local time) '
          ],
          [
            "size",
            "Optional",
            "Set the max number of datapoints to retreive. If not specified, this query returns all avaliable datapoints requested between the time specified. Otherwise, it returns the number (size n) of objects (JSON) or rows (CSV) per ticker. Max is 10,000."
          ],
          [
            "selectedFields",
            "Optional",
            'Choose a list (comma separated) of data fields (in snake case) to return. Default is "all".'
          ],
          data_type_param,
          access_key_param
        ]
      }
    },
    response_params: {
      description: "",
      table_header: response_param_table_header,
      table_data: [
        ["symbol", "String", "Returns the symbol of a future or commodity"],
        [
          "date",
          "String",
          "Returns the date realtime price is traded on. Date format is: yyyy-mm-dd"
        ],
        [
          "latest_price",
          "Number",
          'Returns the latest intraday price for the selected future or commodity. Ex: "123.45"'
        ],
        [
          "volume",
          "Number",
          'Returns the aggregated intraday trade volume for the selected future or commodity. Ex: "123"'
        ],
        [
          "price_change_ratio",
          "Number",
          'Returns the intraday price change ratio for the selected future or commodity. Ex: "123"'
        ],
        [
          "last_close",
          "Number",
          'Returns the close price from the last trading day for the selected future or commodity. Ex: "123.45"'
        ],
        [
          "open",
          "Number",
          'Returns the open price from the last trading day for the selected future or commodity. Ex: "123.45"'
        ],
        [
          "high",
          "Number",
          'Returns the high price from the last trading day for the selected future or commodity. Ex: "123.45"'
        ],
        [
          "low",
          "Number",
          'Returns the low price from the last trading day for the selected future or commodity. Ex: "123.45"'
        ],
        [
          "price_2",
          "Number",
          'Returns the 52 week high price for the selected future or commodity. Ex: "123.45"'
        ],
        [
          "price_3",
          "Number",
          'Returns the 52 week low price for the selected future or commodity. Ex: "123.45"'
        ],
        ["timestamp", "Number", "Returns the timestamp of the price is traded on"],
        ["bid(1-5)", "Number", "Returns the price for the security is purchased at"],
        ["bid_size(1-5)", "Number", "Returns the quantities being purchased"],
        ["ask(1-5)", "Number", "Returns the lowest acceptable price for the security"],
        ["ask_size(1-5)", "Number", "Returns the requested price for the security"]
      ]
    }
  },

  /**
   * Crypto APIs
   */
  "Historical Crypto Price": {
    api_category: v2_api_category[3],
    costs: ["10 credit per data point"],
    description: [
      "Historical Crypto Prices returns a list of most liquid 100 cryptos historical traded price."
    ],
    feature: [
      "Covers 100+ most liquid cryptos traded in major exchanges. To get a full list of cryptos that we cover, you may download a csv.file here.",
      "Includes unadjusted and adjusted open, high, low, close, volume.",
      "Historical data is updated at or before 5:00pm ET on all trading days.",
      "Historical data covers 5 years of data",
      "This API returns intraday time series data (open, high, low, close,  volume) for any specified cryptocurrency."
    ],
    base_url: "https://api.unibit.ai/v2/crypto/historical/",
    template_urls: [
      "https://api.unibit.ai/v2/crypto/historical?tickers={{ticker list}}&startDate={{YYYY-MM-DD}}&endDate={{YYYY-MM-DD}}&size={{a positive number}}&selectedFields={{field list}}&dataType={{json or csv}}&accessKey={{your key}}"
    ],
    example_urls: [
      "https://api.unibit.ai/v2/crypto/historical?tickers=BCH-USD,BNB-USD&startDate=2019-08-25&endDate=2019-08-30&selectedFields=all&accessKey=Demo"
    ],
    csv_urls: [
      "https://api.unibit.ai/v2/crypto/historical?tickers=BCH-USD,BNB-USD&startDate=2019-08-25&endDate=2019-08-30&selectedFields=all&dataType=csv&accessKey=Demo"
    ],
    input_params: {
      query_params: {
        description: "",
        table_header: input_param_table_header,
        table_data: [
          ["tickers", "Required", 'Input crypto-fiat currency symbol. Ex. "BCH-USD" '],
          [
            "startDate",
            "Optional",
            'Choose the start date (in "YYYY-MM-DD" Format). Ex. "2019-08-25". Default is the most recent trading date. Time is in UTC.'
          ],
          [
            "endDate",
            "Optional",
            'Choose the start date (in "YYYY-MM-DD" Format). Ex. "2019-08-25". Default is the most recent trading date. Time is in UTC. '
          ],
          [
            "size",
            "Optional",
            "Set the max number of datapoints to retreive. If not specified, this query returns all prices requested between the time specified. Otherwise, it returns the number (size n) of objects (JSON) or rows (CSV) per crypto. Max is 2,147,483,647."
          ],
          [
            "selectedFields",
            "Optional",
            'Choose a list (comma separated) of data fields (in snake case) to return. Default is "all".'
          ],
          data_type_param,
          access_key_param
        ]
      }
    },
    response_params: {
      meta_data: {
        ticker: "ETH",
        date: "02/02/2020",
        range: "1 month",
        interval: 1
      },
      description: "",
      table_header: response_param_table_header,
      table_data: [
        ["date", "String", "Return date."],
        [
          "open",
          "Number",
          "Returns the highest trading price for the cryptocurrencies of a nature date."
        ],
        [
          "high",
          "Number",
          "Returns the highest trading price for the cryptocurrencies of a nature date."
        ],
        [
          "low",
          "Number",
          "Returns the lowest trading price for the cryptocurrencies of a nature date."
        ],
        ["close", "Number", "Returns the ending price for the cryptocurrencies of a nature date."],
        ["volume", "Number", "Returns trading volume of a nature date."]
      ]
    }
  },

  /**
   * Forex APIs
   */
  // "Realtime Forex Rates": {
  //   api_category: v2_api_category[4],
  //   costs: ["1 credit per data point"],
  //   description: [
  //     "UniBit Real Time FX Rate api returns the latest currencies market conversion rate."
  //   ],
  //   feature: [
  //     "Cover over 20,000 currencies exchanging pairs.",
  //     "Updated every 5 minutes.",
  //     "Real Time FX Rate api only go back 5 months.",
  //     "Time is in UTC."
  //   ],
  //   base_url: "https://api.unibit.ai/v2/forex/realtime/",
  //   template_urls: [
  //     "https://api.unibit.ai/v2/forex/realtime?base={{base currency}}&foreign={{currency list}}&amount={{a positive number}}&selectedFields={{field list}}&startDate={{YYYY-MM-DD}}&endDate={{YYYY-MM-DD}}&startMinute={{HH:MM:SS}}&endMinute={{HH:MM:SS}}&dataType={{json or csv}}&accessKey={{your key}}"
  //   ],
  //   example_urls: [
  //     "https://api.unibit.ai/v2/forex/realtime?base=usd&foreign=cny,eur,inr&amount=1&selectedFields=all&startDate=2019-08-29&endDate=2019-8-29&startMinute=11:00:00&endMinute=12:00:00&accessKey=Demo"
  //   ],
  //   csv_urls: [
  //     "https://api.unibit.ai/v2/forex/realtime?base=usd&foreign=cny,eur,inr&amount=1&selectedFields=all&startDate=2019-08-29&endDate=2019-8-29&startMinute=11:00:00&endMinute=12:00:00&dataType=csv&accessKey=Demo"
  //   ],
  //   input_params: {
  //     query_params: {
  //       description: "",
  //       table_header: input_param_table_header,
  //       table_data: [
  //         ["base", "Required", 'Choose the base currency. Ex. "usd"'],
  //         [
  //           "foreign",
  //           "Optional",
  //           'Choose the foreign currencies (comma separated). Ex. "eur,cny".'
  //         ],
  //         ["amount", "Optional", "Choose the amount of base currency. The default is 1."],
  //         [
  //           "startDate",
  //           "Optional",
  //           'Choose the start date (in "YYYY-MM-DD" Format). Ex. "2019-08-25". Default is the most recent trading date.'
  //         ],
  //         [
  //           "endDate",
  //           "Optional",
  //           'Choose the end date(in "YYYY-MM-DD" Format).Ex. "2019-08-26".Default is the most recent trading date.'
  //         ],
  //         [
  //           "startMinute",
  //           "Optional",
  //           'Choose the specific intraday period(in "HH:MM:SS" format).Ex."11:00:00". Default time is "00:00:00".Time is in UTC.'
  //         ],
  //         [
  //           "endMinute",
  //           "Optional",
  //           'Choose the specific intraday period(in "HH: MM: SS" format).Ex."12:00:00". Default time is "23:59:59".Time is in UTC.'
  //         ],
  //         [
  //           "size",
  //           "Optional",
  //           "Set the max number of datapoints to retreive. If not specified, this query returns all real time prices requested between the time specified. Otherwise, it returns the number (size n) of objects (JSON) or rows (CSV) per currency. Max is 2,147,483,647."
  //         ],
  //         [
  //           "selectedFields",
  //           "Optional",
  //           'Choose a list (comma separated) of data fields (in snake case) to return. Default is "all".'
  //         ],
  //         data_type_param,
  //         access_key_param
  //       ]
  //     }
  //   },
  //   response_params: {
  //     meta_data: {
  //       datapoints: 50,
  //       base: "USD",
  //       "credit cost": 500
  //     },
  //     description: "",
  //     table_header: response_param_table_header,
  //     table_data: [
  //       ["value", "Number", "Return value."],
  //       ["date", "String", "Returns the date FX rate is traded."],
  //       ["minute", "String", "Returns the minute FX rate is traded."],
  //       ["timestamp", "Number", "Returns the timestamp of date and minute."],

  //       ["base", "String", "Returns the symbol of base currency."],
  //       ["foreign", "String", "Returns the symbol of foreign currency."]
  //     ]
  //   }
  // },

  // "Historical Forex Rates": {
  //   api_category: v2_api_category[4],
  //   costs: ["10 credit per data point"],
  //   description: [
  //     "UniBit Real Time FX Rate api returns the latest currencies market conversion rate."
  //   ],
  //   feature: [
  //     "Cover over 20,000 currencies exchanging pairs.",
  //     "Updated daily.",
  //     "Historical FX Rate api goes back 15 years.",
  //     "Time is in UTC."
  //   ],
  //   base_url: "https://api.unibit.ai/v2/forex/historical/",
  //   template_urls: [
  //     "https://api.unibit.ai/v2/forex/historical?base={{base currency}}&foreign={{currency list}}&amount={{a positive number}}&startDate={{YYYY-MM-DD}}&endDate={{YYYY-MM-DD}}&startMinute={{HH:MM:SS}}&endMinute={{HH:MM:SS}}&size={{a positive number}}&selectedFields={{field list}}&dataType={{json or csv}}&accessKey={{your key}}"
  //   ],
  //   example_urls: [
  //     "https://api.unibit.ai/v2/forex/historical?base=usd&foreign=cny,eur,inr&amount=1&startDate=2019-08-20&endDate=2019-08-25&selectedFields=all&accessKey=Demo"
  //   ],
  //   csv_urls: [
  //     "https://api.unibit.ai/v2/forex/historical?base=usd&foreign=cny,eur,inr&amount=1&startDate=2019-08-20&endDate=2019-08-25&selectedFields=all&dataType=csv&accessKey=Demo"
  //   ],
  //   input_params: {
  //     query_params: {
  //       description: "",
  //       table_header: input_param_table_header,
  //       table_data: [
  //         ["base", "Required", 'Choose the base currency. Ex. "usd".'],
  //         [
  //           "foreign",
  //           "Optional",
  //           'Choose the foreign currencies (comma separated). Ex. "eur,cny".'
  //         ],
  //         ["amount", "Optional", "Choose the amount of base currency. The default is 1."],
  //         [
  //           "startDate",
  //           "Optional",
  //           'Choose the start date (in "YYYY-MM-DD" Format). Ex. "2019-08-25". Default is the most recent trading date.'
  //         ],
  //         [
  //           "endDate",
  //           "Optional",
  //           'Choose the end date (in "YYYY-MM-DD" Format). Ex. "2019-08-26". Default is the most recent trading date.'
  //         ],
  //         [
  //           "startMinute",
  //           "Optional",
  //           'Choose the specific intraday period (in "HH:MM:SS" format). Ex. "11:00:00". Default time is "00:00:00". Time is in UTC.'
  //         ],
  //         [
  //           "endMinute",
  //           "Optional",
  //           'Choose the specific intraday period (in "HH:MM:SS" format). Ex."12:00:00". Default time is "23:59:59". Time is in UTC.'
  //         ],
  //         [
  //           "size",
  //           "Optional",
  //           "Set the max number of datapoints to retreive. If not specified, this query returns all real time prices requested between the time specified. Otherwise, it returns the number (size n) of objects (JSON) or rows (CSV) per currency. Max is 2,147,483,647."
  //         ],
  //         [
  //           "selected",
  //           "Optional",
  //           'Choose a list (comma separated) of data fields (in snake case) to return. Default is "all".'
  //         ],
  //         data_type_param,
  //         access_key_param
  //       ]
  //     }
  //   },
  //   response_params: {
  //     meta_data: {
  //       ticker: "ETH",
  //       date: "02/02/2020",
  //       range: "1 month",
  //       interval: 1
  //     },
  //     description: "",
  //     table_header: response_param_table_header,
  //     table_data: [
  //       ["value", "Number", "Return value."],
  //       ["date", "String", "Returns the date FX rate is traded."],
  //       ["minute", "String", "Returns the minute FX rate is traded."],
  //       ["timestamp", "Number", "Returns the timestamp of date and minute."],

  //       ["base", "String", "Returns the symbol of base currency."],
  //       ["foreign", "String", "Returns the symbol of foreign currency."]
  //     ]
  //   }
  // },

  /**
   * Reference APIs
   */

  "Stock Coverage": {
    api_category: v2_api_category[5],
    costs: ["1 credit per data point"],
    description: [
      "This API returns all the assets that we support based on Stock Exchanges. Currently, the API supports 70,000 stocks, and ETFs in 49 global stock exchanges."
    ],
    feature: [
      "Exchange covered: All 49 exchanges in 22 countries.",
      "Updated daily.",
      "Includes Initial Public Offerings (IPOs).",
      "Include Exchange Traded Products (ETPs)"
    ],
    base_url: "https://api.unibit.ai/v2/ref/companyList/",
    template_urls: [
      "https://api.unibit.ai/v2/ref/companyList?dataType={{json or csv}}&accessKey={{your key}}"
    ],
    example_urls: [
      "https://api.unibit.ai/v2/ref/companyList?exchange=NASDAQ&accessKey=YOUR_ACCESS_KEY"
    ],
    csv_urls: [
      "https://api.unibit.ai/v2/ref/companyList?exchange=NASDAQ&dataType=csv&accessKey=YOUR_ACCESS_KEY"
    ],
    possible_options: {
      description: "",
      table_header: ["Exchange Names", "Input Type", "Description"],
      table_data: [
        ["AEX", "String", "Euronext Amsterdam"],
        ["AMEX", "String", "NYSE American Stock Exchange"],
        ["ASX", "String", "Australian Securities Exchange"],
        ["BATS", "String", "BATS Global Markets"],
        ["BCBA", "String", "Buenos Aires Stock Exchange"],
        ["BIST", "String", "Istanbul Stock Exchange"],
        ["BOM", "String", "Bombay Stock Exchange"],
        ["BSE", "String", "Brussels Stock Exchange"],
        ["CNQ", "String", "Canadian Securities Exchange"],
        ["DOH", "String", "Qatar Stock Exchange"],
        ["FRA", "String", "Frankfurt Stock Exchange"],
        ["GER", "String", "Deutsche Börse XETRA"],
        ["HKEX", "String", "Hong Kong Stock Exchange"],
        ["JSE", "String", "Johannesburg Stock Exchange"],
        ["JSX", "String", "Jakarta Stock Exchange"],
        ["KLS", "String", "Kuala Lumpur"],
        ["KSC", "String", "Korean Stock Exchange"],
        ["LSE", "String", "London Stock Exchange"],
        ["MAD", "String", "Madrid Stock Exchange"],
        ["MCX", "String", "Moscow Stock Exchange"],
        ["MEX", "String", "Mexican Stock Exchange"],
        ["MIL", "String", "Milan Stock Exchange"],
        ["NASDAQ", "String", "NASDAQ Stock Exchange"],
        ["NSE", "String", "National Stock Exchange of India"],
        ["NYSE", "String", "New York Stock Exchange"],
        ["NYSEARCA", "String", "NYSE Arca (Archipelago Exchange)"],
        ["NZX", "String", "New Zealand Stock Exchange"],
        ["OMX", "String", "Stockholm Stock Exchange"],
        ["OMXC", "String", "Copenhagen Stock Exchange"],
        ["OMXH", "String", "Helsinki Stock Exchange"],
        ["OMXI", "String", "Iceland Stock Exchange"],
        ["OMXR", "String", "Riga Stock Exchange"],
        ["OMXT", "String", "Tallinn Stock Exchange"],
        ["OMXV", "String", "Vilnius Stock Exchange"],
        ["OTCMKTS", "String", "OTC Markets Group"],
        ["PAR", "String", "Euronext Paris"],
        ["SAO", "String", "Sao Paolo Stock Exchange"],
        ["SES", "String", "Singapore Exchange"],
        ["SET", "String", "Stock Exchange of Thailand"],
        ["SIX", "String", "SIX Swiss Exchange"],
        ["SZCE", "String", "Shenzhen Stock Exchange"],
        ["TADAWUL", "String", "Saudi Stock Exchange"],
        ["TASE", "String", "Tel Aviv Stock Exchange"],
        ["TSX", "String", "Toronto Stock Exchange"],
        ["TSXV", "String", "TSX Venture Exchange"],
        ["TWSE", "String", "Taiwan Stock Exchange"],
        ["TYO", "String", "Tokyo Stock Exchange"],
        ["VSE", "String", "Vienna Stock Exchange"],
        ["WSE", "String", "Warsaw Stock Exchange"]
      ]
    },
    input_params: {
      query_params: {
        description: "",
        table_header: input_param_table_header,
        table_data: [
          [
            "exchange",
            "Optional",
            "Choose symbol of a stock exchange provided in possible options"
          ],
          data_type_param,
          access_key_param
        ]
      }
    },
    response_params: {
      description: "",
      table_header: response_param_table_header,
      table_data: [
        ["ticker", "String", "Return company’s ticker"],
        ["companyName", "String", "Return company’s name"],
        ["exchange", "String", "Returns the exchange that the security is traded in."],
        [
          "exchangeShort",
          "String",
          "Returns the exchange's abbreviation that the security is traded in."
        ],
        ["currency", "String", "Returns the currency that the security is traded with."],
        ["timezone", "String", "Returns the timezone that the security is traded in."]
      ]
    }
  },

  "Futures and Commodities Coverage": {
    api_category: v2_api_category[2],
    costs: ["1 credit per data point"],
    description: [
      "This API returns all the futures and commodities that we support based on Exchanges. Currently, the API supports 300+ Futures and Commodities in 12 global stock exchanges."
    ],
    feature: ["Exchange covered: 12 exchanges.", "Updated daily."],
    base_url: "https://api.unibit.ai/v2/ref/commodityList/",
    template_urls: [
      "https://api.unibit.ai/v2/ref/commodityList?dataType={{json or csv}}&accessKey={{your key}}"
    ],
    example_urls: [
      "https://api.unibit.ai/v2/ref/commodityList?exchange=COMEX&accessKey=YOUR_ACCESS_KEY"
    ],
    csv_urls: [
      "https://api.unibit.ai/v2/ref/commodityList?exchange=COMEX&dataType=csv&accessKey=YOUR_ACCESS_KEY"
    ],
    possible_options: {
      description: "",
      table_header: ["Exchange Names", "Input Type", "Description"],
      table_data: [
        ["CBOT", "String", "Chicago Board of Trade"],
        ["COMEX", "String", "COMEX Commodity Exchange"],
        ["GBTC", "String", "Global Bitcoin Futures"],
        ["GFTSE", "String", "Global FTSE Index Futures"],
        ["GFX", "String", "Global Fx Futures"],
        ["GSIF", "String", "Global Stock Index Futures"],
        ["ICE", "String", "Intercontinental Exchange"],
        ["IPE", "String", "International Petroleum Exchange"],
        ["LME", "String", "London Metal Exchange"],
        ["LMEOS", "String", "London Metal Exchange (Spot Contract) OS"],
        ["LMEPM", "String", "London Metal Exchange (Spot Contract) PM"],
        ["NYMEX", "String", "New York Mercantile Exchange"],
        ["SES", "String", "Singapore Exchange"]
      ]
    },
    input_params: {
      query_params: {
        description: "",
        table_header: input_param_table_header,
        table_data: [
          ["exchange", "Optional", "Choose symbol of a exchange provided in possible options"],
          data_type_param,
          access_key_param
        ]
      }
    },
    response_params: {
      description: "",
      table_header: response_param_table_header,
      table_data: [
        ["symbol", "String", "Returns the symbol of the commodity or future."],
        ["symbolDescription", "String", "Returns the name of the commodity."],
        ["exchangeName", "String", "Returns the exchange that the security is traded in."],
        [
          "exchangeShort",
          "String",
          "Returns the exchange's abbreviation that the security is traded in."
        ],
        ["date", "String", "Returns the expiration of the commodity or future."],
        ["assetType", "String", "Returns the asset type of the commodity or future."],
        ["country", "String", "Returns the country where the exchange's headquarter is."]
      ]
    }
  },

  "Crypto Coverage": {
    api_category: v2_api_category[5],
    costs: ["1 credit per data point"],
    description: ["This API returns all the crypto currencies that we support."],
    feature: ["Updated daily"],
    base_url: "https://api.unibit.ai/v2/ref/cryptoList/",
    template_urls: [
      "https://api.unibit.ai/v2/ref/cryptoList?dataType={{json or csv}}&accessKey={{your key}}"
    ],
    example_urls: ["https://api.unibit.ai/v2/ref/cryptoList?accessKey=YOUR_ACCESS_KEY"],
    csv_urls: ["https://api.unibit.ai/v2/ref/cryptoList?dataType=csv&accessKey=YOUR_ACCESS_KEY"],
    input_params: {
      query_params: {
        description: "",
        table_header: input_param_table_header,
        table_data: [data_type_param, access_key_param]
      }
    },
    response_params: {
      meta_data: {
        ticker: "AAPL",
        date: "02/02/2020"
      },
      description: "",
      table_header: response_param_table_header,
      table_data: [
        ["ticker", "String", "Return currency’s ticker."],
        ["name", "String", "Return currency's name."],
        ["currency", "String", "Returns the currency that the security is traded with."]
      ]
    }
  }
};
export default V2_API;

const ticker_input_params = {
  input: API_CONTROL_PANEL_INPUT_TYPE.TEXT_INPUT,
  name: "tickers",
  value: "Please enter your ticker here",
  isRequired: true,
  isPathParam: false
};
const ticker_optional_input_params = {
  input: API_CONTROL_PANEL_INPUT_TYPE.TEXT_INPUT,
  name: "tickers",
  value: "Please enter your ticker here",
  isRequired: false,
  isPathParam: false
};

const forex_base_input_params = {
  input: API_CONTROL_PANEL_INPUT_TYPE.ONE_CHOICE,
  name: "base",
  value: FOREX_LIST,
  isRequired: true,
  isPathParam: false
};
const start_date_input_params = {
  input: API_CONTROL_PANEL_INPUT_TYPE.TEXT_INPUT,
  name: "startDate",
  value: "Please enter a date: YYYY-MM-DD",
  isRequired: false,
  isPathParam: false
};
const end_date_input_params = {
  input: API_CONTROL_PANEL_INPUT_TYPE.TEXT_INPUT,
  name: "endDate",
  value: "Please enter a date: YYYY-MM-DD",
  isRequired: false,
  isPathParam: false
};

const start_date_required_input_params = {
  input: API_CONTROL_PANEL_INPUT_TYPE.TEXT_INPUT,
  name: "startDate",
  value: "Please enter a date: YYYY-MM-DD",
  isRequired: true,
  isPathParam: false
};
const end_date_required_input_params = {
  input: API_CONTROL_PANEL_INPUT_TYPE.TEXT_INPUT,
  name: "endDate",
  value: "Please enter a date: YYYY-MM-DD",
  isRequired: true,
  isPathParam: false
};

const start_minute_input_params = {
  input: API_CONTROL_PANEL_INPUT_TYPE.TEXT_INPUT,
  name: "startMinute",
  value: "Please enter a time: HH:MM:SS",
  isRequired: false,
  isPathParam: false
};
const end_minute_input_params = {
  input: API_CONTROL_PANEL_INPUT_TYPE.TEXT_INPUT,
  name: "endMinute",
  value: "Please enter a time: HH:MM:SS",
  isRequired: false,
  isPathParam: false
};
const selected_fields_input_params = {
  input: API_CONTROL_PANEL_INPUT_TYPE.TEXT_INPUT,
  name: "selectedFields",
  value: "a comma separated list",
  isRequired: false,
  isPathParam: false
};
const size_input_params = {
  input: API_CONTROL_PANEL_INPUT_TYPE.NUMBER_INPUT,
  name: "size",
  value: "Must be a positive integer",
  isRequired: false,
  isPathParam: false
};
const datatype_input_params = {
  input: API_CONTROL_PANEL_INPUT_TYPE.ONE_CHOICE,
  name: "dataType",
  value: ["json", "csv"],
  isRequired: false,
  isPathParam: false
};
const accesskey_input_params = {
  input: API_CONTROL_PANEL_INPUT_TYPE.ACCESSKEY_TEXT_INPUT,
  name: "accessKey",
  value: "Please enter your access key here",
  isRequired: true,
  isPathParam: false
};

export const v2_api_input_params = {
  // "US Realtime Stock Price": {
  //   ticker_input_params,
  //   start_date_input_params,
  //   end_date_input_params,
  //   start_minute_input_params,
  //   end_minute_input_params,
  //   size_input_params,
  //   selected_fields_input_params,
  //   datatype_input_params,
  //   accesskey_input_params
  // },
  // "Realtime Stock Price": {
  //   ticker_input_params,
  //   start_date_input_params,
  //   end_date_input_params,
  //   start_minute_input_params,
  //   end_minute_input_params,
  //   size_input_params,
  //   selected_fields_input_params,
  //   datatype_input_params,
  //   accesskey_input_params
  // },
  "Historical Stock Price": {
    ticker_input_params,
    interval_input_params: {
      input: API_CONTROL_PANEL_INPUT_TYPE.NUMBER_INPUT,
      name: "interval",
      value: "Must be a positive integer",
      isRequired: false,
      isPathParam: false
    },
    start_date_input_params,
    end_date_input_params,
    selected_fields_input_params,
    datatype_input_params,
    accesskey_input_params
  },
  // "Stock Technical Indicators": {
  //     ticker_input_params,
  //     function_input_params: { input: API_CONTROL_PANEL_INPUT_TYPE.ONE_CHOICE, name: "function", value: TECHNICAL_INDICATORS, isRequired: true, isPathParam: false },
  //     start_date_input_params,
  //     end_date_input_params,
  //     interval_frequency_input_params: { input: API_CONTROL_PANEL_INPUT_TYPE.ONE_CHOICE, name: "intervalFrequency", value: ["daily", "weekly", "monthly"], isRequired: false, isPathParam: false },
  //     datapoint_input_params: { input: API_CONTROL_PANEL_INPUT_TYPE.NUMBER_INPUT, name: "dataPoint", value: "Must be a positive integer", isRequired: false, isPathParam: false },
  //     series_input_params: { input: API_CONTROL_PANEL_INPUT_TYPE.ONE_CHOICE, name: "seriesType", value: ["open", "close", "high", "low"], isRequired: false, isPathParam: false },
  //     selected_fields_input_params,
  //     datatype_input_params,
  //     accesskey_input_params
  // },
  "Company Financials": {
    ticker_input_params,
    interval_input_params: {
      input: API_CONTROL_PANEL_INPUT_TYPE.ONE_CHOICE,
      name: "interval",
      value: ["A", "Q", "TTM"],
      isRequired: false,
      isPathParam: false
    },
    statement_input_params: {
      input: API_CONTROL_PANEL_INPUT_TYPE.ONE_CHOICE,
      name: "statement",
      value: ["IS", "BS", "CF"],
      isRequired: false,
      isPathParam: false
    },
    start_date_required_input_params,
    end_date_required_input_params,
    selected_fields_input_params,
    datatype_input_params,
    accesskey_input_params
  },
  "Company Profile": {
    ticker_input_params,
    selected_fields_input_params,
    datatype_input_params,
    accesskey_input_params
  },
  "Company Financial Summary": {
    ticker_input_params,
    selected_fields_input_params,
    datatype_input_params,
    accesskey_input_params
  },
  "Ownership Structure": {
    ticker_input_params,
    type_input_params: {
      input: API_CONTROL_PANEL_INPUT_TYPE.ONE_CHOICE,
      name: "ownershipType",
      value: ["majority_holder", "top_institutional_holder", "top_mutual_fund_holder"],
      isRequired: true,
      isPathParam: false
    },
    start_date_input_params,
    end_date_input_params,
    selected_fields_input_params,
    datatype_input_params,
    accesskey_input_params
  },
  "Insider Transaction": {
    ticker_input_params,
    start_date_input_params,
    end_date_input_params,
    size_input_params,
    selected_fields_input_params,
    datatype_input_params,
    accesskey_input_params
  },
  "SEC Filing Link": {
    ticker_input_params,
    start_date_input_params,
    end_date_input_params,
    selected_fields_input_params,
    datatype_input_params,
    accesskey_input_params
  },
  "Stock News": {
    ticker_input_params,
    start_date_input_params,
    end_date_input_params,
    start_minute_input_params,
    end_minute_input_params,
    size_input_params,
    genre_input_params: {
      input: API_CONTROL_PANEL_INPUT_TYPE.ONE_CHOICE,
      name: "genre",
      value: EVENT_GENRE,
      isRequired: false,
      isPathParam: false
    },
    sector_input_params: {
      input: API_CONTROL_PANEL_INPUT_TYPE.ONE_CHOICE,
      name: "sector",
      value: EVENT_SECTOR,
      isRequired: false,
      isPathParam: false
    },
    selected_fields_input_params,
    datatype_input_params,
    accesskey_input_params
  },
  "Corporate Splits": {
    ticker_input_params: {
      input: API_CONTROL_PANEL_INPUT_TYPE.TEXT_INPUT,
      name: "tickers",
      value: "Please enter your ticker here",
      isRequired: false,
      isPathParam: false
    },
    start_date_input_params: {
      input: API_CONTROL_PANEL_INPUT_TYPE.TEXT_INPUT,
      name: "startDate",
      value: "Please enter a date: YYYY-MM-DD",
      isRequired: true,
      isPathParam: false
    },
    end_date_input_params: {
      input: API_CONTROL_PANEL_INPUT_TYPE.TEXT_INPUT,
      name: "endDate",
      value: "Please enter a date: YYYY-MM-DD",
      isRequired: true,
      isPathParam: false
    },
    size_input_params,
    selected_fields_input_params,
    datatype_input_params,
    accesskey_input_params
  },
  "Corporate Dividends": {
    ticker_input_params: {
      input: API_CONTROL_PANEL_INPUT_TYPE.TEXT_INPUT,
      name: "tickers",
      value: "Please enter your ticker here",
      isRequired: false,
      isPathParam: false
    },
    start_date_input_params: {
      input: API_CONTROL_PANEL_INPUT_TYPE.TEXT_INPUT,
      name: "startDate",
      value: "Please enter a date: YYYY-MM-DD",
      isRequired: true,
      isPathParam: false
    },
    end_date_input_params: {
      input: API_CONTROL_PANEL_INPUT_TYPE.TEXT_INPUT,
      name: "endDate",
      value: "Please enter a date: YYYY-MM-DD",
      isRequired: true,
      isPathParam: false
    },
    size_input_params,
    selected_fields_input_params,
    datatype_input_params,
    accesskey_input_params
  },
  "Stock Analyst Ratings": {
    ticker_optional_input_params,
    start_date_input_params,
    end_date_input_params,
    size_input_params,
    selected_fields_input_params,
    datatype_input_params,
    accesskey_input_params
  },
  "Historical Crypto Price": {
    ticker_input_params,
    start_date_input_params,
    end_date_input_params,
    size_input_params,
    selected_fields_input_params,
    datatype_input_params,
    accesskey_input_params
  },
  // "Realtime Forex Rates": {
  //   forex_base_input_params,
  //   foreign_input_params: {
  //     input: API_CONTROL_PANEL_INPUT_TYPE.TEXT_INPUT,
  //     name: "foreign",
  //     value: "Enter comma separated values of currencies.",
  //     isRequired: false,
  //     isPathParam: false
  //   },
  //   amount_input_params: {
  //     input: API_CONTROL_PANEL_INPUT_TYPE.NUMBER_INPUT,
  //     name: "amount",
  //     value: "Enter the amount of base currency",
  //     isRequired: false,
  //     isPathParam: false
  //   },
  //   start_date_input_params,
  //   end_date_input_params,
  //   start_minute_input_params,
  //   end_minute_input_params,
  //   size_input_params,
  //   selected_fields_input_params,
  //   datatype_input_params,
  //   accesskey_input_params
  // },
  // "Historical Forex Rates": {
  //   forex_base_input_params,
  //   foreign_input_params: {
  //     input: API_CONTROL_PANEL_INPUT_TYPE.TEXT_INPUT,
  //     name: "foreign",
  //     value: "Enter comma separated values of currencies.",
  //     isRequired: false,
  //     isPathParam: false
  //   },
  //   amount_input_params: {
  //     input: API_CONTROL_PANEL_INPUT_TYPE.NUMBER_INPUT,
  //     name: "amount",
  //     value: "Enter the amount of base currency",
  //     isRequired: false,
  //     isPathParam: false
  //   },
  //   start_date_input_params,
  //   end_date_input_params,
  //   start_minute_input_params,
  //   end_minute_input_params,
  //   size_input_params,
  //   selected_fields_input_params,
  //   datatype_input_params,
  //   accesskey_input_params
  // },
  "Stock Coverage": {
    exchange_input_params: {
      input: API_CONTROL_PANEL_INPUT_TYPE.ONE_CHOICE,
      name: "exchange",
      value: EXCHANGE_LIST,
      isRequired: false,
      isPathParam: false
    },
    datatype_input_params,
    accesskey_input_params
  },
  "Futures and Commodities Coverage": {
    exchange_input_params: {
      input: API_CONTROL_PANEL_INPUT_TYPE.ONE_CHOICE,
      name: "exchange",
      value: FUTURE_COMMODITY_EXCHANGE_LIST,
      isRequired: false,
      isPathParam: false
    },
    datatype_input_params,
    accesskey_input_params
  },
  "Crypto Coverage": {
    datatype_input_params,
    accesskey_input_params
  }
};



// WEBPACK FOOTER //
// ./src/assets/apiDocs/stock_api_v2.js